export default "__VITE_ASSET__HegvykKI__"